import React from "react";
import { RangoItemMenu, RangoListItemMenu, RangoListMenu } from "@rango/core";
import { FooterViewProps } from "./FooterViews.types";

const FooterMobile: React.FC<FooterViewProps> = ({
	gridFooter,
}: FooterViewProps) => {
	const handleClick = (link: string) => {
		window.open(link, "_self", "noreferrer");
	};

	return (
		<div className="rango-col-1 rango-col-md-12 rango-col-lg-4 rango-col-xl-4">
			<RangoListMenu type="Vertical">
				{gridFooter.listColumns?.map((column, index) => (
					<RangoListItemMenu
						key={index}
						index={index}
						label={column.title}
						type="Vertical"
						inverse
						showSubMenu
					>
						{column.listColumnItens?.map((item, index) => {
							const targetProps = {
								title: item.target?.title,
								element_parent: item.target?.elementParent,
								element_type: item.target?.elementType,
								destination: item.target?.destination,
							};

							return (
								<RangoItemMenu
									{...targetProps}
									className="footer__link-mobile"
									as="a"
									key={index}
									index={index}
									inverse
									href={item.link}
									label={item.label}
								/>
							);
						})}
					</RangoListItemMenu>
				))}
			</RangoListMenu>
		</div>
	);
};

export default FooterMobile;
